import { render } from "./ConsumerDutyComponent.vue?vue&type=template&id=ee90daf0&scoped=true"
import script from "./ConsumerDutyComponent.vue?vue&type=script&lang=js"
export * from "./ConsumerDutyComponent.vue?vue&type=script&lang=js"

import "./ConsumerDutyComponent.vue?vue&type=style&index=0&id=ee90daf0&scoped=true&lang=css"

import exportComponent from "/tmp/build_905a1b4c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee90daf0"]])

export default __exports__